// Mock data for Colombian Body Med Spa

export const businessInfo = {
  name: "Colombian Body Contour Spa",
  rating: 5.0,
  address: "3960 Broadway Blvd Ste 205, Garland, TX 75043",
  phone: "(469) 536-6652",
  hours: "Open daily – Closes at 6 PM",
  qrCode: "qrco.de",
  coordinates: {
    lat: 32.9126,
    lng: -96.6389
  }
};

export const services = {
  bodyContouring: [
    {
      id: "fat-burners",
      name: "Fat Burners (Quemadores)",
      description: "Non-invasive fat reduction treatments targeting stubborn areas for a sculpted silhouette.",
      duration: "45-60 min",
      category: "Body Contouring & Sculpting"
    },
    {
      id: "cellulite-removal",
      name: "Cellulite Removal",
      description: "Advanced technology to smooth skin texture and reduce the appearance of cellulite.",
      duration: "60 min",
      category: "Body Contouring & Sculpting"
    },
    {
      id: "fajas-reductoras",
      name: "Fajas Reductoras",
      description: "Professional fitting and consultation for post-treatment compression garments.",
      duration: "30 min",
      category: "Body Contouring & Sculpting"
    },
    {
      id: "lymphatic-massage",
      name: "Lymphatic Massages",
      description: "Therapeutic massage promoting natural detoxification and reducing swelling.",
      duration: "60-90 min",
      category: "Body Contouring & Sculpting"
    },
    {
      id: "post-op-care",
      name: "Post-Op Care",
      description: "Specialized recovery treatments supporting healing after cosmetic procedures.",
      duration: "60 min",
      category: "Body Contouring & Sculpting"
    },
    {
      id: "post-parto",
      name: "Post-Parto Treatments",
      description: "Customized treatments helping mothers restore their body confidence after pregnancy.",
      duration: "60-90 min",
      category: "Body Contouring & Sculpting"
    }
  ],
  beauty: [
    {
      id: "skin-lotions",
      name: "Skin Lotions",
      description: "Premium professional-grade skincare products for enhanced treatment results.",
      duration: "Consultation",
      category: "Beauty Services"
    },
    {
      id: "cejas",
      name: "Cejas (Eyebrows)",
      description: "Professional eyebrow shaping and enhancement for perfectly defined brows.",
      duration: "30 min",
      category: "Beauty Services"
    },
    {
      id: "pestanas",
      name: "Pestañas (Lashes)",
      description: "Eyelash extensions and treatments for fuller, longer-looking lashes.",
      duration: "60-90 min",
      category: "Beauty Services"
    },
    {
      id: "bigote",
      name: "Bigote (Upper Lip)",
      description: "Gentle and effective upper lip hair removal for smooth, flawless skin.",
      duration: "15 min",
      category: "Beauty Services"
    },
    {
      id: "permanent-hair-straightening",
      name: "Permanent Hair Straightening",
      description: "Transform curly or wavy hair into sleek, straight locks with our keratin-based permanent straightening treatment. This long-lasting solution smooths frizz, adds shine, and makes styling effortless for months.",
      duration: "3-4 hours",
      category: "Beauty Services"
    }
  ],
  nails: [
    {
      id: "manicure",
      name: "Manicure",
      description: "Professional manicure service including nail shaping, cuticle care, hand massage, and polish application. Choose from classic polish, gel, or specialty finishes for beautiful, long-lasting results.",
      duration: "3 hours - Varies",
      category: "Nails"
    }
  ],
  fajas: [
    {
      id: "fajas-women",
      name: "Colombian Fajas for Women",
      description: "Authentic Colombian compression fajas designed for women. Our dual-size design adapts as your body changes, so one faja fits you through every stage. Patent-owned craftsmanship for superior compression, comfort, and sculpting.",
      duration: "Fitting available",
      category: "Fajas"
    },
    {
      id: "fajas-men",
      name: "Colombian Fajas for Men",
      description: "Authentic Colombian compression fajas designed for men. Dual-size fit adjusts with your body for lasting wear. Patent-owned design delivering firm compression, posture support, and all-day comfort.",
      duration: "Fitting available",
      category: "Fajas"
    }
  ],
  flyers: [
    {
      id: "terapias-reductoras",
      name: "Terapias Reductoras",
      description: "Body contouring treatments - Real results!",
      orientation: "square",
      image: "terapias-reductoras.jpg",
      category: "Flyers"
    },
    {
      id: "cavitacion-lipo",
      name: "Cavitación Lipo/Ultra",
      description: "Non-invasive body sculpting",
      orientation: "square",
      image: "cavitacion-lipo.png",
      category: "Flyers"
    },
    {
      id: "cellulite-spanish",
      name: "Celulitis - Dile Adiós",
      description: "Cellulite treatment in Spanish",
      orientation: "square",
      image: "cellulite-spanish.png",
      category: "Flyers"
    },
    {
      id: "cellulite-english",
      name: "Cellulite - Tell It Goodbye",
      description: "Cellulite treatment in English",
      orientation: "square",
      image: "cellulite-english.png",
      category: "Flyers"
    },
    {
      id: "cavitation-gimnasia-pasiva",
      name: "Cavitación y Gimnasia Pasiva",
      description: "Body contouring with ultrasound - Say goodbye to sagging",
      orientation: "square",
      image: "cavitation-gimnasia-pasiva.png",
      category: "Flyers"
    },
    {
      id: "beauty-shine",
      name: "Let Your Beauty Shine",
      description: "Expert beauty treatments",
      orientation: "landscape",
      image: "beauty-shine.png",
      category: "Flyers"
    },
    {
      id: "masajes-posoperatorios",
      name: "Masajes Posoperatorios",
      description: "Post-op lymphatic massages",
      orientation: "landscape",
      image: "masajes-posoperatorios.png",
      category: "Flyers"
    }
  ]
};

export const whyChooseUs = [
  {
    id: 1,
    title: "5-Star Rated on Google",
    description: "Consistently excellent reviews from satisfied clients"
  },
  {
    id: 2,
    title: "Experienced & Certified Professionals",
    description: "Licensed aestheticians with advanced training"
  },
  {
    id: 3,
    title: "Personalized Treatment Plans",
    description: "Customized solutions tailored to your unique needs"
  },
  {
    id: 4,
    title: "Clean & Comfortable Environment",
    description: "State-of-the-art facility with the highest safety standards"
  },
  {
    id: 5,
    title: "Spanish & English Speaking",
    description: "Bilingual staff to serve our diverse community"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Maria Rodriguez",
    rating: 5,
    text: "Amazing experience! The staff is professional and caring. I love my results!",
    service: "Facial Treatments"
  },
  {
    id: 2,
    name: "Jennifer Smith",
    rating: 5,
    text: "Best spa in Garland! Clean facility, friendly staff, and incredible results.",
    service: "Lymphatic Massage"
  },
  {
    id: 3,
    name: "Carmen Lopez",
    rating: 5,
    text: "I've been coming here for months and the service is always excellent. Highly recommend!",
    service: "Body Contouring"
  }
];

export const beforeAfterGallery = [
  {
    id: 2,
    category: "Body Contouring",
    description: "Visible fat reduction results"
  },
  {
    id: 4,
    category: "Cellulite Treatment",
    description: "Improved skin texture"
  },
  {
    id: 5,
    category: "Facial Treatments",
    description: "Radiant, glowing skin"
  },
  {
    id: 7,
    category: "Armpit Skin Lightening",
    description: "Even skin tone"
  },
  {
    id: 8,
    category: "Permanent Hair Straightening",
    description: "Hair treatment"
  },
  {
    id: 9,
    category: "Eyebrow Lamination/Henna",
    description: "Your eyes best complement"
  }
];

export const translations = {
  en: {
    hero: {
      headline: "Enhance Your Natural Beauty with Expert Aesthetic Care",
      subheadline: "Advanced treatments. Personalized results. 5-Star Rated Care.",
      cta1: "Book Appointment",
      cta2: "Call Now"
    },
    nav: {
      about: "About",
      services: "Services",
      whyUs: "Why Choose Us",
      reviews: "Reviews",
      gallery: "Gallery",
      contact: "Contact"
    },
    about: {
      title: "About Us",
      description: "Colombian Body Contour Spa in Garland, TX offers advanced aesthetic and body contouring treatments designed to enhance your natural beauty and confidence. With 5-star service and personalized care, we specialize in results-driven treatments in a welcoming, professional environment."
    },
    services: {
      title: "Our Services",
      subtitle: "Comprehensive aesthetic treatments tailored to your needs"
    },
    whyUs: {
      title: "Why Choose Us"
    },
    reviews: {
      title: "What Our Clients Say",
      rating: "Google Rating"
    },
    gallery: {
      title: "Before & After Gallery",
      subtitle: "Real results from real clients"
    },
    contact: {
      title: "Visit Us",
      form: {
        title: "Book Your Appointment",
        name: "Full Name",
        email: "Email Address",
        phone: "Phone Number",
        service: "Select Service",
        date: "Preferred Date",
        message: "Message (Optional)",
        submit: "Request Appointment"
      },
      info: {
        hours: "Hours",
        address: "Address",
        phone: "Phone"
      }
    },
    footer: {
      tagline: "Serving Garland, TX and surrounding areas",
      rights: "All rights reserved"
    }
  },
  es: {
    hero: {
      headline: "Realza Tu Belleza Natural con Cuidado Estético Experto",
      subheadline: "Tratamientos avanzados. Resultados personalizados. Atención calificada con 5 estrellas.",
      cta1: "Reservar Cita",
      cta2: "Llamar Ahora"
    },
    nav: {
      about: "Nosotros",
      services: "Servicios",
      whyUs: "Por Qué Elegirnos",
      reviews: "Reseñas",
      gallery: "Galería",
      contact: "Contacto"
    },
    about: {
      title: "Sobre Nosotros",
      description: "Colombian Body Contour Spa en Garland, TX ofrece tratamientos estéticos avanzados y de contorneado corporal diseñados para realzar su belleza natural y confianza. Con servicio de 5 estrellas y atención personalizada, nos especializamos en tratamientos orientados a resultados en un ambiente acogedor y profesional."
    },
    services: {
      title: "Nuestros Servicios",
      subtitle: "Tratamientos estéticos integrales adaptados a sus necesidades"
    },
    whyUs: {
      title: "Por Qué Elegirnos"
    },
    reviews: {
      title: "Lo Que Dicen Nuestros Clientes",
      rating: "Calificación de Google"
    },
    gallery: {
      title: "Galería Antes y Después",
      subtitle: "Resultados reales de clientes reales"
    },
    contact: {
      title: "Visítenos",
      form: {
        title: "Reserve Su Cita",
        name: "Nombre Completo",
        email: "Correo Electrónico",
        phone: "Número de Teléfono",
        service: "Seleccionar Servicio",
        date: "Fecha Preferida",
        message: "Mensaje (Opcional)",
        submit: "Solicitar Cita"
      },
      info: {
        hours: "Horario",
        address: "Dirección",
        phone: "Teléfono"
      }
    },
    footer: {
      tagline: "Sirviendo a Garland, TX y áreas circundantes",
      rights: "Todos los derechos reservados"
    }
  }
};
